import { User } from '../../../generated/graphql';

const state: {
  user: null;
} = {
  user: null
};
export default state;
